export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey.length === 2:
      return betKey

    case splitKey.length === 3:
      return splitKey[2]

    case splitKey.length === 4:
      return `${splitKey[2]}:${splitKey[3]}`
  }
}
